import { render } from "./InputMultipleAnswers.vue?vue&type=template&id=16e0ab41"
import script from "./InputMultipleAnswers.vue?vue&type=script&lang=js"
export * from "./InputMultipleAnswers.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__